(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class OppCustomSizeFields extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog, product-card');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
      this.setVisibility(this.dataset.visible === 'true');
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = async (event) => {
      const { detail } = await event.promise;
      if (detail?.productId !== this.dataset.productId) return;
      this.setVisibility(detail.resource?.title === this.dataset.customValue);
    };

    setVisibility(visible) {
      this.hidden = !visible;
      for (const input of this.querySelectorAll('input, select, textarea')) {
        input.disabled = !visible;
        input.required = visible && input.hasAttribute('data-required');
      }
    }
  }

  if (!customElements.get('opp-custom-size-fields')) {
    customElements.define('opp-custom-size-fields', OppCustomSizeFields);
  }

  class CustomizeQuoteLink extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.link?.addEventListener('pointerenter', this.updateHref);
      this.link?.addEventListener('focus', this.updateHref);
      this.link?.addEventListener('click', this.updateHref);
    }

    disconnectedCallback() {
      this.link?.removeEventListener('pointerenter', this.updateHref);
      this.link?.removeEventListener('focus', this.updateHref);
      this.link?.removeEventListener('click', this.updateHref);
    }

    updateHref = () => {
      if (!this.link) return;

      const productScope = this.closest('product-information, featured-product-information, .shopify-section');
      const variantPicker = productScope?.querySelector('variant-picker');
      const productForm = this.closest('product-form-component')?.querySelector('form');
      const selectedOptions = [];
      const customFields = [];
      let material = '';
      let currentVariant = null;

      try {
        currentVariant = JSON.parse(variantPicker?.querySelector('script[type="application/json"]')?.textContent || 'null');
      } catch {
        currentVariant = null;
      }

      for (const option of variantPicker?.querySelectorAll('select option:checked, fieldset input:checked') || []) {
        const name = option.dataset.optionName || '';
        const value = option.value || option.textContent?.trim() || '';
        if (!value) continue;
        selectedOptions.push(name ? `${name}: ${value}` : value);
        if (name.toLowerCase().includes('material')) material = value;
      }

      for (const field of productForm?.querySelectorAll('[name^="properties["]:not(:disabled)') || []) {
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;
        const value = field.value?.trim();
        if (!value) continue;
        const name = field.name.replace(/^properties\[/, '').replace(/\]$/, '');
        customFields.push(`${name}: ${value}`);
      }

      const url = new URL('/pages/contact', window.location.origin);
      url.searchParams.set('source', 'product_page');
      url.searchParams.set('product', this.dataset.productHandle || '');
      url.searchParams.set('product_name', this.dataset.productTitle || '');
      url.searchParams.set('product_url', window.location.href);
      url.searchParams.set('source_page', window.location.href);

      const optionSummary = selectedOptions.join(' | ') || currentVariant?.public_title || this.dataset.variantTitle || '';
      if (optionSummary) url.searchParams.set('selected_options', optionSummary);
      if (customFields.length) url.searchParams.set('custom_fields', customFields.join(' | '));
      const sku = currentVariant?.sku || this.dataset.variantSku || '';
      if (sku) url.searchParams.set('sku', sku);
      if (material) url.searchParams.set('material', material);

      url.hash = 'custom-quote-form';
      this.link.href = url.toString();
    };
  }

  if (!customElements.get('customize-quote-link')) {
    customElements.define('customize-quote-link', CustomizeQuoteLink);
  }
  } catch(e) { console.error(e); }
})();

})();
